function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#F7C488",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "26%",
  stopColor: "#F9A77D",
  stopOpacity: 0.29
}), /*#__PURE__*/React.createElement("stop", {
  offset: "63%",
  stopColor: "#FC826E",
  stopOpacity: 0.67
}), /*#__PURE__*/React.createElement("stop", {
  offset: "88%",
  stopColor: "#FE6A65",
  stopOpacity: 0.91
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FF6161"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero",
  transform: "translate(0 2)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 147.75,
  cy: 149.75,
  r: 147.75,
  fill: "url(#a)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(43.5 .236)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 77.5,
  cy: 259.264,
  fill: "#15406B",
  opacity: 0.5,
  rx: 77.5,
  ry: 7.5
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#15406B",
  strokeWidth: 3,
  transform: "translate(1.702)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#607A94",
  d: "M161.955 243.424l-147.548 7.733a3 3 0 0 1-3.15-2.835L.623 16.887c-.041-.795.235-3.573.768-4.164a3 3 0 0 1 2.074-.986c36.913-1.288 64.598-2.42 83.054-3.398 13.999-.74 34.997-3.52 62.993-8.335 1.653-.085 3.062 7.183 3.15 8.835l12.136 231.435a3 3 0 0 1-2.843 3.15z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C7D1DB",
  d: "M3.133 15.483l99.853-2.341 47.755-3.07a3 3 0 0 1 3.192 2.942l4.043 234.57a3.002 3.002 0 0 1-2.948 3.052L7.301 253.214a3 3 0 0 1-3.052-2.947L.204 18.535a3 3 0 0 1 2.93-3.052z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 155.25,
  height: 237.75,
  y: 18.499,
  fill: "#FFF",
  rx: 3
})), /*#__PURE__*/React.createElement("g", {
  fill: "#15406B",
  opacity: 0.29,
  transform: "translate(14.5 147.764)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 129,
  height: 13.62,
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  width: 91.356,
  height: 5.481,
  y: 22.839,
  rx: 2.741
}), /*#__PURE__*/React.createElement("rect", {
  width: 76.13,
  height: 5.481,
  y: 32.584,
  rx: 2.741
}), /*#__PURE__*/React.createElement("rect", {
  width: 98.969,
  height: 5.481,
  y: 42.633,
  rx: 2.741
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(14.21 60.514)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 130,
  height: 79.267,
  fill: "#15406B",
  opacity: 0.29,
  rx: 6.705
}), /*#__PURE__*/React.createElement("rect", {
  width: 39,
  height: 35,
  y: 147.518,
  fill: "#15406B",
  opacity: 0.29,
  rx: 6.705
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 53.325,
  cy: 29.16,
  fill: "#FFF",
  rx: 4.793,
  ry: 4.92
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M83.498 52.958L70.702 30a1.642 1.642 0 0 0-1.387-.832 1.598 1.598 0 0 0-1.388.862l-8.46 15.87-4.89-6.27a1.553 1.553 0 0 0-1.417-.615c-.545.063-1.02.4-1.26.892l-6.398 13.126a1.657 1.657 0 0 0 .698 2.204c.231.122.489.184.75.18h35.168a1.59 1.59 0 0 0 1.387-.817 1.71 1.71 0 0 0-.007-1.642zM29.371 171.063l-6.666-12.244a.853.853 0 0 0-.723-.444.83.83 0 0 0-.723.46l-4.408 8.464-2.548-3.344a.8.8 0 0 0-.738-.328.837.837 0 0 0-.657.476l-3.333 7a.894.894 0 0 0 .363 1.176c.12.065.255.098.391.096h18.323c.3 0 .577-.167.723-.436a.93.93 0 0 0-.004-.876z"
})), /*#__PURE__*/React.createElement("rect", {
  width: 67,
  height: 5.481,
  x: 60.5,
  y: 208.764,
  fill: "#15406B",
  opacity: 0.29,
  rx: 2.741
}), /*#__PURE__*/React.createElement("rect", {
  width: 56,
  height: 5.481,
  x: 60.5,
  y: 218.509,
  fill: "#15406B",
  opacity: 0.29,
  rx: 2.741
}), /*#__PURE__*/React.createElement("rect", {
  width: 73,
  height: 5.481,
  x: 60.5,
  y: 228.558,
  fill: "#15406B",
  opacity: 0.29,
  rx: 2.741
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M98.475 52.107h3.21v-.593H100.5v-4.785h2.4l3.09 5.378h1.5v-.593h-.862l-2.88-4.965a2.775 2.775 0 0 0 2.482-3v-.45c0-1.912-1.065-2.932-3.585-2.932h-4.17v.57h1.11v10.777h-1.11v.593zm2.002-6v-5.348h2.018c1.98 0 2.827.653 2.827 2.363v.517c0 1.725-.997 2.483-2.745 2.483l-2.1-.015zm9.75 6.09a3.488 3.488 0 0 0 2.655-1.193h.038a1.057 1.057 0 0 0 1.222 1.14c.222 0 .442-.036.653-.105v-.525h-.36c-.518 0-.75-.187-.75-.915v-5.58c0-1.747-1.073-2.332-2.678-2.332-.95 0-1.89.2-2.76.585v.585a7.388 7.388 0 0 1 2.603-.48c1.297 0 2.002.375 2.002 1.755v1.56l-2.602.322c-1.5.188-2.64.825-2.64 2.348v.547c0 1.455.877 2.318 2.625 2.318m.15-.585c-1.29 0-1.965-.66-1.965-1.763v-.615c0-1.185.847-1.672 2.085-1.792l2.332-.225v3.247a3.472 3.472 0 0 1-2.452 1.103m4.08 3.157h3v-.555h-1.215v-2.572a5.062 5.062 0 0 0 2.505.547c2.123 0 3.75-1.26 3.75-4.5v-.75c0-3.397-1.5-4.245-3.413-4.245a4.095 4.095 0 0 0-2.827 1.14h-.015v-.997h-1.793v.585h.998v10.822h-.998v.555l.008-.03zm4.23-3.21a4.552 4.552 0 0 1-2.4-.555v-6.555a3.84 3.84 0 0 1 2.587-1.057c1.673 0 2.79.637 2.79 3.525v.862c0 2.843-1.357 3.81-3 3.81m4.328 3.21h3v-.555h-1.17v-2.602a5.018 5.018 0 0 0 2.498.547c2.122 0 3.75-1.26 3.75-4.5v-.75c0-3.397-1.463-4.245-3.413-4.245a4.11 4.11 0 0 0-2.828 1.14h-.037v-.997H123v.585h.997v10.822H123v.555zm4.23-3.21a4.552 4.552 0 0 1-2.4-.555v-6.585a3.84 3.84 0 0 1 2.587-1.057c1.673 0 2.79.637 2.79 3.525v.862c0 2.843-1.357 3.81-3 3.81m8.25.653c2.175 0 3.75-1.26 3.75-4.5v-.623c0-3.21-1.62-4.455-3.75-4.455s-3.75 1.283-3.75 4.455v.66c0 3.203 1.605 4.5 3.75 4.5m0-.637c-1.657 0-2.932-.953-2.932-3.705v-.87c0-2.76 1.275-3.75 2.932-3.75 1.658 0 2.933.967 2.933 3.75v.832c0 2.753-1.238 3.705-2.933 3.705m3.938.518h3v-.593h-1.14v-6.495a3.997 3.997 0 0 1 3.06-1.5v-.75a3.638 3.638 0 0 0-3.038 1.605h-.037v-1.545h-1.83v.585h1.02v8.1h-.998v.57l-.037.023zm8.152.105c.447.003.89-.068 1.313-.21v-.533a4.875 4.875 0 0 1-1.05.12c-.825 0-1.14-.382-1.14-1.177v-6.998h2.19v-.585h-2.19v-1.987h-.825v1.987h-1.163v.585h1.163v7.125c0 1.155.547 1.673 1.702 1.673"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#003961",
  d: "M19.635 52.107h3.712v-2.25h-.592l-2.512-4.5 2.535-3h.547v-2.25H18.69v2.25h.653l-2.535 2.917v-2.895h.652v-2.25h-5.25v2.25h.638v7.5h-.638v2.25h5.25v-2.25h-.652v-1.792l.442-.398 2.385 4.418zm8.317.21c2.745 0 4.613-1.62 4.613-4.748v-.6c0-3.127-1.883-4.747-4.613-4.747-2.73 0-4.567 1.62-4.567 4.747v.6c0 3.128 1.845 4.748 4.567 4.748m0-2.453c-.66 0-.937-.412-.937-1.71v-1.635c0-1.282.277-1.71.937-1.71s.93.428.93 1.71v1.635c0 1.298-.277 1.71-.93 1.71m4.733 2.25h4.5v-2.25h-.33v-4.687c.24-.15.513-.236.795-.248.413 0 .608.158.608.75v4.208h-.345v2.25h4.222v-2.25h-.33v-4.71a1.62 1.62 0 0 1 .795-.248c.413 0 .608.158.608.75v4.208h-.33v2.25h4.5v-2.25h-.585v-5.453c0-1.552-1.02-2.25-2.333-2.25a3.24 3.24 0 0 0-2.722 1.245h-.09a2.115 2.115 0 0 0-2.138-1.245 3.15 3.15 0 0 0-2.677 1.223h-.083v-.975h-4.072v2.332h.622v5.085h-.622v2.25l.007.015zm14.917 0h4.5v-2.25h-.33v-4.687c.24-.151.513-.237.796-.248.412 0 .6.158.6.75v4.208h-.346v2.25h4.23v-2.25h-.33v-4.71c.239-.152.513-.237.795-.248.413 0 .608.158.608.75v4.208h-.33v2.25h4.5v-2.25h-.593v-5.453c0-1.552-1.012-2.25-2.325-2.25a3.263 3.263 0 0 0-2.73 1.245h-.082a2.122 2.122 0 0 0-2.137-1.245 3.15 3.15 0 0 0-2.678 1.26h-.068v-1.012h-4.057v2.332h.623v5.085h-.623l-.023 2.265zm17.873.21c.964.051 1.9-.328 2.557-1.035h.083v.825h4.058v-2.25h-.608v-7.432H67.41v2.332h.585v4.5a1.35 1.35 0 0 1-.847.278c-.48 0-.653-.225-.653-.81v-6.3H62.34v2.332h.585v4.935c0 1.605.623 2.588 2.55 2.588m6.96-.21h4.5v-2.25h-.36v-4.635a1.77 1.77 0 0 1 .893-.263c.435 0 .622.158.622.75v4.208h-.36v2.25h4.5v-2.25h-.585v-5.453c0-1.552-1.05-2.25-2.362-2.25a3.3 3.3 0 0 0-2.745 1.223H76.5v-.975h-4.057v2.332h.622v5.085h-.622v2.25l-.008-.022zm12.615.187c1.155 0 2.123-.397 2.52-1.275h.068c.172.75.705 1.223 2.122 1.223.56.03 1.122-.042 1.658-.21v-2.123h-.263c-.255 0-.345-.097-.345-.375v-4.335c0-2.122-1.26-2.947-3.675-2.947a12.098 12.098 0 0 0-3.9.637v2.348c.744-.12 1.496-.179 2.25-.173 1.365 0 1.778.203 1.778.75v.48l-1.83.278c-1.583.24-2.933.847-2.933 2.64v.48c0 1.905.983 2.61 2.573 2.61m1.567-2.018a.667.667 0 0 1-.705-.705v-.675a.825.825 0 0 1 .863-.93l.465-.052v2.122a.787.787 0 0 1-.623.278m4.95 1.845h4.8v-2.25h-.622V39.514H91.59v2.25h.623v8.175h-.623v2.198z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#15406B",
  opacity: 0.3,
  transform: "translate(12.75 29.764)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 51.75,
  height: 3,
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 22.5,
  height: 3,
  x: 55.5,
  rx: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 33.75,
  height: 3,
  x: 83.25,
  rx: 1.5
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(71.75 58.25)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 98.25,
  cy: 231.5,
  fill: "#15406B",
  opacity: 0.5,
  rx: 98.25,
  ry: 6
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(12.224)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 168,
  height: 226.5,
  x: 2.276,
  y: 2.25,
  fill: "#FFF",
  rx: 4.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "#15406B",
  d: "M165.776 4.5a2.25 2.25 0 0 1 2.25 2.25v217.5a2.25 2.25 0 0 1-2.25 2.25h-159a2.25 2.25 0 0 1-2.25-2.25V6.75a2.25 2.25 0 0 1 2.25-2.25h159m0-4.5h-159a6.75 6.75 0 0 0-6.75 6.75v217.5a6.75 6.75 0 0 0 6.75 6.75h159a6.75 6.75 0 0 0 6.75-6.75V6.75a6.75 6.75 0 0 0-6.75-6.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#15406B",
  d: "M171.026 14.25h-171v6c0-16.5-1.44-19.5 17.25-19.5h137.94c15.81 0 15.81 3 15.81 19.5v-6zM3.026 215.25h166.5V228H3.026z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#15406B",
  opacity: 0.29,
  transform: "translate(28.75 144)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 138.75,
  height: 13.418,
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 90,
  height: 5.4,
  y: 22.5,
  rx: 2.7
}), /*#__PURE__*/React.createElement("rect", {
  width: 75,
  height: 5.4,
  y: 32.1,
  rx: 2.7
}), /*#__PURE__*/React.createElement("rect", {
  width: 97.5,
  height: 5.4,
  y: 42,
  rx: 2.7
}), /*#__PURE__*/React.createElement("rect", {
  width: 62.4,
  height: 5.4,
  y: 51.6,
  rx: 2.7
})), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M116.845 42.63h3.21v-.57h-1.208v-4.815h2.4l3.083 5.385h1.5v-.57h-.863l-2.88-4.973a2.76 2.76 0 0 0 2.483-3v-.45c0-1.92-1.065-2.932-3.585-2.932h-4.163v.563h1.11v10.815h-1.11v.577l.023-.03zm2.002-6v-5.355h2.018c1.98 0 2.828.66 2.828 2.363v.517c0 1.725-.998 2.482-2.746 2.482h-2.1v-.007zm9.75 6.09a3.51 3.51 0 0 0 2.655-1.192h.038a1.057 1.057 0 0 0 1.222 1.132c.222.001.442-.031.653-.097v-.518h-.36c-.517 0-.75-.195-.75-.915v-5.61c0-1.74-1.073-2.325-2.677-2.325a6.676 6.676 0 0 0-2.76.585v.585a7.215 7.215 0 0 1 2.602-.488c1.297 0 2.002.383 2.002 1.763v1.553l-2.587.315c-1.5.187-2.64.825-2.64 2.34v.555c0 1.455.877 2.317 2.625 2.317m.15-.592c-1.29 0-1.965-.653-1.965-1.755v-.57c0-1.193.847-1.673 2.085-1.793l2.333-.225v3.24a3.442 3.442 0 0 1-2.453 1.103m4.08 3.157h3v-.547h-1.178v-2.61a5.07 5.07 0 0 0 2.505.555c2.123 0 3.75-1.26 3.75-4.5v-.75c0-3.398-1.462-4.245-3.412-4.245a4.125 4.125 0 0 0-2.835 1.132v-.997h-1.8v.585h1.005v10.815h-1.005v.555l-.03.007zm4.222-3.21a4.613 4.613 0 0 1-2.392-.547V34.95a3.855 3.855 0 0 1 2.587-1.05c1.673 0 2.79.638 2.79 3.518v.832c0 2.85-1.365 3.81-3 3.81m4.29 3.21h3v-.547h-1.177v-2.61a5.07 5.07 0 0 0 2.505.555c2.122 0 3.75-1.26 3.75-4.5v-.75c0-3.398-1.463-4.246-3.413-4.246a4.095 4.095 0 0 0-2.827 1.133h-.038v-.997h-1.792v.585h.997v10.815h-.997v.555l-.008.007zm4.23-3.21a4.62 4.62 0 0 1-2.4-.547V34.95a3.87 3.87 0 0 1 2.588-1.05c1.672 0 2.79.638 2.79 3.518v.832c0 2.85-1.358 3.81-3 3.81m8.25.66c2.175 0 3.75-1.26 3.75-4.5v-.622c0-3.203-1.628-4.448-3.75-4.448-2.123 0-3.75 1.275-3.75 4.448v.652c0 3.21 1.597 4.5 3.75 4.5m0-.637c-1.658 0-2.933-.953-2.933-3.75v-.825c0-2.76 1.275-3.75 2.933-3.75 1.657 0 2.932.967 2.932 3.75v.825c0 2.76-1.237 3.75-2.932 3.75m3.937.517h3v-.57h-1.14v-6.525a4.012 4.012 0 0 1 3.053-1.5v-.75a3.653 3.653 0 0 0-3 1.605h-.038v-1.552h-1.867v.585h1.02v8.13h-1.02v.57l-.008.007zm8.153.105c.446.002.89-.069 1.312-.21V42a4.897 4.897 0 0 1-1.05.113c-.832 0-1.14-.375-1.14-1.17v-6.998h2.19v-.592h-2.182v-1.98h-.833v1.98h-1.155v.585h1.155v7.125c0 1.162.555 1.68 1.71 1.68"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#003961",
  d: "M38.005 42.63h3.705v-2.25h-.585l-2.513-4.5 2.535-3h.548v-2.25h-4.643v2.25h.698l-2.535 2.918V32.88h.652v-2.25h-5.25v2.25h.638v7.5h-.638v2.25h5.25v-2.25h-.652v-1.793l.427-.397 2.363 4.44zm8.317.202c2.746 0 4.613-1.62 4.613-4.74V37.5c0-3.12-1.883-4.74-4.612-4.74-2.73 0-4.568 1.62-4.568 4.74v.607c0 3.12 1.845 4.74 4.568 4.74m0-2.444c-.653 0-.93-.42-.93-1.71V37.05c0-1.275.277-1.702.93-1.702.652 0 .937.427.937 1.702v1.643c0 1.29-.277 1.71-.937 1.71m4.74 2.25h4.5v-2.25h-.33v-4.71c.24-.145.514-.228.795-.24.412 0 .6.157.6.75v4.207h-.345v2.25h4.23v-2.25h-.263V35.7c.24-.146.514-.228.795-.24.413 0 .608.157.608.75v4.208h-.33v2.25h4.5v-2.25h-.585V34.95c0-1.553-1.02-2.205-2.333-2.205a3.255 3.255 0 0 0-2.722 1.238h-.09a2.123 2.123 0 0 0-2.138-1.238 3.15 3.15 0 0 0-2.677 1.223h-.068v-1.02h-4.072v2.362h.622v5.092h-.622v2.25h-.075zm14.917 0h4.5v-2.25h-.33v-4.71c.24-.146.514-.229.795-.24.413 0 .6.157.6.75v4.207H71.2v2.25h4.23v-2.25h-.33V35.7c.24-.146.514-.228.795-.24.413 0 .6.157.6.75v4.208h-.322v2.25h4.462v-2.25h-.585V34.95c0-1.553-1.012-2.205-2.325-2.205a3.278 3.278 0 0 0-2.73 1.238h-.082a2.123 2.123 0 0 0-2.138-1.238 3.15 3.15 0 0 0-2.677 1.223h-.068v-1.02h-4.072v2.362h.622v5.092h-.622l.022 2.25zm17.873.202a3.225 3.225 0 0 0 2.557-1.035h.09v.833h4.057v-2.25h-.607v-7.455h-4.155v2.362h.585v4.545a1.35 1.35 0 0 1-.847.27c-.48 0-.653-.225-.653-.81v-6.367h-4.155v2.362h.585v4.935c0 1.605.623 2.588 2.55 2.588m6.96-.203h4.5v-2.25h-.36v-4.695c.27-.163.578-.251.893-.255.435 0 .622.15.622.75v4.207h-.36v2.25h4.5v-2.25h-.585V34.95c0-1.553-1.05-2.205-2.362-2.205a3.293 3.293 0 0 0-2.745 1.222h-.083v-1.02h-4.057v2.363h.622v5.092h-.622v2.25l.037-.022zm12.593.172c1.155 0 2.122-.397 2.52-1.282H106c.173.75.705 1.23 2.123 1.23a4.785 4.785 0 0 0 1.65-.21v-2.137h-.255c-.263 0-.345-.105-.345-.383v-4.327c0-2.123-1.26-2.956-3.675-2.956a11.867 11.867 0 0 0-3.9.645v2.34a14.31 14.31 0 0 1 2.25-.172c1.365 0 1.777.21 1.777.75v.465l-1.83.278c-1.59.24-2.932.84-2.932 2.64v.48c0 1.897.982 2.61 2.572 2.61m1.568-2.018a.668.668 0 0 1-.705-.712v-.675a.825.825 0 0 1 .862-.93l.465-.053V40.5a.787.787 0 0 1-.622.278m4.95 1.845h4.8v-2.25h-.623V30h-4.177v2.25h.622v8.175h-.622v2.197z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(28.75 57)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 138.75,
  height: 77.25,
  fill: "#15406B",
  opacity: 0.29,
  rx: 6.705
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  opacity: 0.5,
  transform: "translate(54 23.25)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8.617,
  cy: 5.168,
  r: 4.793
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.782 28.358l-12.75-22.38a1.665 1.665 0 0 0-1.395-.81A1.59 1.59 0 0 0 23.25 6l-8.46 15.473-4.897-6.113a1.575 1.575 0 0 0-1.418-.607 1.613 1.613 0 0 0-1.26.877L.818 28.417A1.598 1.598 0 0 0 2.25 30.75h35.167c.572.002 1.101-.3 1.388-.795a1.62 1.62 0 0 0-.023-1.597z"
})))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(42.84 124)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 52.16,
  cy: 184.5,
  fill: "#15406B",
  opacity: 0.5,
  rx: 52,
  ry: 4.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "#15406B",
  d: "M44.16 164.5l.495-148.71V.25H98.16c6.96 0 14.25 6.817 14.25 13.357V164.5H44.16z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(9 7)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 86.25,
  height: 175.5,
  x: 1.508,
  y: 1.5,
  fill: "#FFF",
  rx: 10.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "#15406B",
  d: "M77.25 3a9 9 0 0 1 9 9v154.5a9 9 0 0 1-9 9H12a9 9 0 0 1-9-9V12a9 9 0 0 1 9-9h65.25m0-3H12C5.373 0 0 5.373 0 12v154.5c0 6.627 5.373 12 12 12h65.25c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#15406B",
  d: "M62.722 9h-36c-4.14 0-6-3.69-6-8.25h48c0 4.56-1.86 8.25-6 8.25z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M36.233 48.032h2.25v-.397h-.848v-3.397h1.688l2.175 3.794h1.072v-.397h-.607l-2.025-3.502a1.958 1.958 0 0 0 1.747-2.146v-.315c0-1.35-.75-2.062-2.527-2.062h-2.933V40h.75v7.62h-.75v.405l.008.008zm1.41-4.214V40h1.417c1.402 0 1.995.465 1.995 1.672v.36c0 1.216-.705 1.748-1.927 1.748h-1.5l.015.038zm6.87 4.29a2.49 2.49 0 0 0 1.875-.84.75.75 0 0 0 .862.802c.158-.001.315-.026.465-.075v-.36h-.255c-.367 0-.547-.135-.547-.645v-3.953c0-1.23-.75-1.642-1.89-1.642-.67 0-1.331.14-1.943.412v.443a5.205 5.205 0 0 1 1.837-.345c.908 0 1.41.27 1.41 1.245v1.095l-1.83.217c-1.042.135-1.86.585-1.86 1.65v.39c0 1.028.623 1.635 1.853 1.635m.113-.412c-.915 0-1.388-.465-1.388-1.245v-.397c0-.84.592-1.178 1.5-1.268l1.642-.157v2.287c-.451.47-1.072.74-1.724.75m2.864 2.25h2.108v-.39h-.825v-1.83a3.608 3.608 0 0 0 1.762.39c1.5 0 2.648-.893 2.648-3.188v-.51c0-2.4-1.035-3-2.407-3a2.902 2.902 0 0 0-1.995.803v-.72H47.52v.412h.705v7.613h-.705v.39l-.022.03zm3-2.25a3.3 3.3 0 0 1-1.694-.39v-4.68a2.715 2.715 0 0 1 1.83-.75c1.177 0 1.964.45 1.964 2.482v.608c0 2.002-.96 2.685-2.1 2.685m3 2.25h2.1v-.39h-.825v-1.83a3.608 3.608 0 0 0 1.763.39c1.5 0 2.648-.892 2.648-3.187v-.51c0-2.4-1.028-3-2.408-3a2.918 2.918 0 0 0-1.995.802V41.5h-1.267v.412h.712v7.613h-.712v.39l-.015-.015zm3-2.25a3.3 3.3 0 0 1-1.694-.39v-4.635a2.715 2.715 0 0 1 1.83-.75c1.177 0 1.965.45 1.965 2.483v.607c0 2.002-.96 2.685-2.1 2.685m5.812.465c1.5 0 2.663-.892 2.663-3.15V44.5c0-2.25-1.148-3.135-2.663-3.135s-2.655.9-2.655 3.135v.443c0 2.25 1.133 3.15 2.655 3.15m0-.458c-1.17 0-2.07-.667-2.07-2.61V44.5c0-1.942.9-2.625 2.07-2.625s2.062.683 2.062 2.625v.585c0 1.943-.87 2.61-2.062 2.61m2.775.368h2.093v-.398h-.803v-4.597a2.805 2.805 0 0 1 2.153-1.058v-.525a2.565 2.565 0 0 0-2.138 1.133V41.5H65.1v.413h.75v5.73h-.705v.397l-.06.023zm5.745.075c.314.004.626-.047.923-.15v-.375a3.12 3.12 0 0 1-.75.082c-.578 0-.803-.262-.803-.825v-4.935h1.545V41.5h-1.56v-1.395H69.6V41.5h-.81v.412h.81v5.018c0 .817.39 1.185 1.208 1.185"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#003961",
  d: "M29.557 33.317h2.603V31.75h-.412l-1.778-3.165 1.792-2.123h.398v-1.567h-3.277V26.5h.464l-1.785 2.055V26.5h.458v-1.567h-3.69V26.5h.45v5.25h-.45v1.567h3.69V31.75h-.458v-1.267l.3-.278 1.695 3.113zm5.865.143c1.928 0 3.24-1.14 3.24-3.338v-.427c0-2.205-1.32-3.345-3.24-3.345-1.92 0-3.224 1.147-3.224 3.345v.427c0 2.198 1.297 3.338 3.224 3.338m0-1.725c-.464 0-.652-.293-.652-1.2V29.38c0-.9.187-1.208.652-1.208.466 0 .66.308.66 1.208v1.155c0 .907-.195 1.2-.66 1.2m3.338 1.582h3.188V31.75h-.233v-3.323c.17-.101.364-.158.563-.165.292 0 .42.105.42.518v3h-.24v1.567h3V31.75h-.233v-3.323c.17-.102.364-.158.563-.165.292 0 .427.105.427.518v3h-.232v1.567h3.15V31.75h-.413v-3.84a1.5 1.5 0 0 0-1.642-1.56 2.287 2.287 0 0 0-1.92.877h-.06a1.5 1.5 0 0 0-1.5-.877 2.25 2.25 0 0 0-1.913.9h-.045v-.75h-2.872v1.665h.442v3.585h-.442v1.567h-.008zm10.5 0h3.188V31.75h-.233v-3.323c.17-.101.364-.158.563-.165.292 0 .42.105.42.518v3h-.24v1.567h3V31.75h-.233v-3.323c.17-.102.364-.158.563-.165.292 0 .427.105.427.518v3h-.232v1.567h3.15V31.75h-.413v-3.84a1.5 1.5 0 0 0-1.642-1.56 2.302 2.302 0 0 0-1.928.877h-.06a1.5 1.5 0 0 0-1.5-.877 2.25 2.25 0 0 0-1.883.862h-.044V26.5H49.29v1.665h.435v3.585h-.435l-.03 1.567zm12.6.143a2.25 2.25 0 0 0 1.8-.75h.06v.585h2.858V31.75h-.428V26.5h-2.932v1.665h.442v3.195a.952.952 0 0 1-.592.195c-.345 0-.465-.158-.465-.57v-4.5h-2.925v1.665h.412v3.472c0 1.133.435 1.823 1.8 1.823m4.898-.143h3.202V31.75h-.255v-3.308a1.26 1.26 0 0 1 .63-.18c.308 0 .443.105.443.518v3h-.263v1.567h3.18V31.75h-.412v-3.84a1.5 1.5 0 0 0-1.665-1.56 2.317 2.317 0 0 0-1.935.862h-.053V26.5h-2.857v1.665h.435v3.585h-.435v1.567l-.015-.015zm8.88.12a1.792 1.792 0 0 0 1.77-.9h.052c.12.533.495.863 1.5.863.395.021.79-.024 1.17-.135v-1.5h-.18c-.188 0-.248-.075-.248-.27v-3.052c0-1.5-.885-2.078-2.587-2.078a8.536 8.536 0 0 0-2.753.45v1.65a10.29 10.29 0 0 1 1.575-.12c.96 0 1.253.15 1.253.548v.33l-1.29.195c-1.118.172-2.07.592-2.07 1.86v.337a1.605 1.605 0 0 0 1.815 1.838m1.102-1.418a.472.472 0 0 1-.495-.502v-.473a.585.585 0 0 1 .608-.66l.33-.037v1.5a.57.57 0 0 1-.443.195m3.495 1.297h3.375v-1.59h-.435v-7.335h-2.94v1.575h.435v5.76h-.435v1.59z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BBC8D4",
  d: "M11.91 56.583h83.25v51.667H11.91z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M56.767 76.832a.982.982 0 0 1 .818.473l7.455 13.05-.023-.023a.937.937 0 0 1-.81 1.395H43.695a.945.945 0 0 1-.89-.647.93.93 0 0 1 .057-.71l3.75-7.455a.93.93 0 0 1 1.568-.158l2.85 3.563 4.935-9a.937.937 0 0 1 .802-.488zm-9.322-2.797a2.797 2.797 0 1 1 0 5.595 2.797 2.797 0 0 1 0-5.595z",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("g", {
  fill: "#15406B",
  opacity: 0.29,
  transform: "translate(19.86 116)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 69.3,
  height: 12,
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 68.55,
  height: 3.78,
  y: 18.665,
  rx: 1.89
}), /*#__PURE__*/React.createElement("rect", {
  width: 52.5,
  height: 3.78,
  y: 25.97,
  rx: 1.89
}), /*#__PURE__*/React.createElement("rect", {
  width: 67.5,
  height: 3.78,
  y: 33.275,
  rx: 1.89
}), /*#__PURE__*/React.createElement("rect", {
  width: 52.5,
  height: 3.78,
  y: 40.58,
  rx: 1.89
}), /*#__PURE__*/React.createElement("rect", {
  width: 63,
  height: 3.78,
  y: 47.885,
  rx: 1.89
}))));

var SvgKrAvis = function SvgKrAvis(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 315,
    viewBox: "0 0 296 315",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKrAvis, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kr_avis.a9140545.svg";
export { ForwardRef as ReactComponent };